import { trigger, transition, style, animate } from '@angular/animations';

export const SlideInOutAnimationName = 'slideInOut';
export const SlideInOutAnimationTag = `@${SlideInOutAnimationName}`;

export const SlideInOutAnimation = trigger(SlideInOutAnimationName, [
    transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate(
            '650ms ease-in',
            style({ transform: 'translateX(0)', opacity: 1 }),
        ),
    ]),
    transition(':leave', [
        style({ transform: 'translateX(0)', opacity: 1 }),
        animate(
            '650ms ease-out',
            style({ transform: 'translateX(100%)', opacity: 0 }),
        ),
    ]),
]);
